import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import SkipLinks from './skipLinks';

window.skipLinkComp = () => {
  const container = document.getElementById('skipLinkCompId');
  if (container) {
    const root = createRoot(container);
    root.render(
      <Suspense fallback={null}>
        <SkipLinks />
      </Suspense>
    );
  }
};
